<template>
  <div id="rwa_launch_pad_div" class="rwa_launch_pad_div">

    <div class="rwa_launch_pad_page_01">
      <Menu/>
    </div>

    <div id="rwa_launch_pad_page_02" ref="rwa_launch_pad_page_02" class="rwa_launch_pad_page_02">
      <div class="rwa_launch_pad_page_02_01">
        <div class="rwa_launch_pad_page_02_011">

          <img class="rwa_launch_pad_page_02_011_bj01" src="../../assets/images/Ellipse_bjl.png"/>
          <img class="rwa_launch_pad_page_02_011_bj03" src="../../assets/images/Ellipse_bjr.png"/>

          <div class="rwa_launch_pad_page_02_0111">
            <div class="rwa_launch_pad_page_02_0111_rut" @click="toIndex()">
              <img src="../../assets/images/fhui.png"/>
              <div>{{ lang('home') }}</div>
            </div>

            <div class="rwa_launch_pad_divs">
              <div class="rwa_launch_pad_title">发射台</div>

              <div class="rwa_launch_pad_div01">
                <div class="rwa_launch_pad_div011">
                  <div class="rwa_launch_pad_div0111">LOGO图像 <span style="color: #FF0000">*</span></div>

                  <el-upload
                  ref="uploadLaunchPadLogo"
                  :action="imgHost + '/api/v1/artlaunch/' + tokenAddress + '/upload'"
                  :data="uploadFormData"
                  :on-remove="launchPadHandleRemove"
                  :on-progress="launchPadHandleProgress"
                  :on-success="launchPadUploadSuccess"
                  :before-upload="launchPadUpload"
                  :on-change="launchPadHandleChange"
                  list-type="picture"
                  :file-list="launchPadList"
                  :limit="1"
                  :show-file-list="true"
                  :auto-upload="false"
                  accept="image/jpeg,image/jpg,image/png,image/svg,image/gif"
                  class="rwa_launch_pad_div0112">
                    <div class="rwa_launch_pad_div01120" v-if="launchPadList.length > 0" @click.stop="launchPadSubmitUpload">
                      上传Logo
                    </div>
                    <div class="rwa_launch_pad_div01121" v-if="launchPadList.length === 0">
                      <img src="../../assets/images/dajia.png"/>
                    </div>
                    <div class="rwa_launch_pad_div01122">
                      <p>jpeg/jpg/png/gif</p>
                      <p>( < 10MB )</p>
                    </div>
                  </el-upload>

                </div>
                <div class="rwa_launch_pad_div012">
                  <div class="rwa_launch_pad_div0121">
                    <div class="rwa_launch_pad_div01211">
                      <div>Token名称 <span style="color: #FF0000">*</span></div>
                      <div :style="(tokenName && tokenName.length > 20) ? 'color: #FF0000' : ''">{{tokenName ? tokenName.length : 0}}/20</div>
                    </div>
                    <div class="rwa_launch_pad_div01212">
                      <el-input
                          placeholder="请输入Token名称"
                          v-model="tokenName"
                          maxlength="21"
                          clearable>
                      </el-input>
                    </div>
                  </div>
                  <div class="rwa_launch_pad_div0122">
                    <div class="rwa_launch_pad_div01221">
                      <div>Token符号 <span style="color: #FF0000">*</span></div>
                      <div :style="(tokenSymbol && tokenSymbol.length > 20) ? 'color: #FF0000' : ''">{{tokenSymbol ? tokenSymbol.length : 0}}/20</div>
                    </div>
                    <div class="rwa_launch_pad_div01222">
                      <el-input
                          placeholder="请输入Token符号"
                          v-model="tokenSymbol"
                          maxlength="21"
                          clearable>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="rwa_launch_pad_div02">
                <div class="rwa_launch_pad_div021">官网</div>
                <div class="rwa_launch_pad_div022">
                  <el-input
                      placeholder="请输入官网"
                      v-model="tokenWebsite"
                      clearable>
                  </el-input>
                </div>
              </div>

              <div class="rwa_launch_pad_div03">
                <div class="rwa_launch_pad_div031">
                  <div class="rwa_launch_pad_div0311">
                    <div>Telegram</div>
                    <div :style="(tokenTelegram && tokenTelegram.length > 20) ? 'color: #FF0000' : ''">{{tokenTelegram ? tokenTelegram.length : 0}}/20</div>
                  </div>
                  <div class="rwa_launch_pad_div0312">
                    <el-input
                        placeholder="请输入Telegram"
                        v-model="tokenTelegram"
                        maxlength="21"
                        clearable>
                    </el-input>
                  </div>
                </div>
                <div class="rwa_launch_pad_div032">
                  <div class="rwa_launch_pad_div0321">
                    <div>Twitter</div>
                    <div :style="(tokenTwitter && tokenTwitter.length > 20) ? 'color: #FF0000' : ''">{{tokenTwitter ? tokenTwitter.length : 0}}/20</div>
                  </div>
                  <div class="rwa_launch_pad_div0322">
                    <el-input
                        placeholder="请输入Twitter"
                        v-model="tokenTwitter"
                        maxlength="21"
                        clearable>
                    </el-input>
                  </div>
                </div>
              </div>

<!--              <div class="rwa_launch_pad_div04">-->
<!--                <div class="rwa_launch_pad_div041">池子数量</div>-->
<!--                <div class="rwa_launch_pad_div042">-->
<!--                  <div class="rwa_launch_pad_div0421">-->
<!--                    <el-input-->
<!--                        placeholder="请输入池子数量"-->
<!--                        v-model="tokenPoolNum"-->
<!--                        clearable>-->
<!--                    </el-input>-->
<!--                  </div>-->
<!--                  <div class="rwa_launch_pad_div0422">BNB <img src="../../assets/images/bnb_logo.png"/></div>-->
<!--                </div>-->
<!--              </div>-->

              <div class="rwa_launch_pad_div05">
                <div class="rwa_launch_pad_div051">
                  <div>描述 <span style="color: #FF0000">*</span></div>
                  <div :style="(tokenDesc && tokenDesc.length > 1000) ? 'color: #FF0000' : ''">{{tokenDesc ? tokenDesc.length : 0}}/1000</div>
                </div>
                <div class="rwa_launch_pad_div052">
                  <el-input
                      type="textarea"
                      placeholder="请输入描述"
                      v-model="tokenDesc"
                      maxlength="1001"
                      :clearable="true">
                  </el-input>
                </div>
              </div>

              <div class="rwa_launch_pad_div06" @click="toLaunchPad()">
                <div>发射</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="rwa_launch_pad_page_03">
        <Bottom/>
      </div>
    </div>

  </div>
</template>

<script>
import {
  cutAccount,
  lang,
  BigNumber,
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub
} from '../../tools/index';

import transfer from "../../tools/transfer";
import Menu from "../../components/Menu";
import Bottom from "../../components/Bottom";
import * as metaMaskTools from "../../tools/chain";

import {
  debug,
  uploadHost
} from "@/config";
import { mixin1 } from "@/tools/mixins";
import toolUtils, { setDecimal, toTextDate } from "@/tools/toolUtils";

export default {
  name: "LaunchPad",
  components: {Menu, Bottom},
  mixins: [mixin1],
  data() {
    return {
      projectId: null,
      tokenAddress: null,
      imgHost: uploadHost,
      launchPadAddNum: 0,
      launchPadList: [],
      uploadFormData: {
        file_type: 'image',
      },
      tokenName: null,
      tokenSymbol: null,
      tokenWebsite: null,
      tokenTelegram: null,
      tokenTwitter: null,
      tokenPoolNum: null,
      tokenDesc: null,
    };
  },
  created() {
    this.projectId = this.$route.query.projectId;
  },
  mounted() {
    this.projectId = this.$route.query.projectId;
  },
  watch: {},
  beforeDestroy() {
  },
  methods: {
    lang(key) {
      return lang(key);
    },
    cutAccount(account, num) {
      return cutAccount(account, num);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    toTextDate(timestamp, isAll) {
      if (isAll) {
        return toTextDate(timestamp).substr(0, 16);
      } else {
        return toTextDate(timestamp).substr(5, 11);
      }
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      // await this.initLaunchPageData();
    },
    toIndex() {
      transfer.$emit("toMenuPage", 1);
    },
    // 文件列表移除文件时的钩子
    launchPadHandleRemove(file, fileList) {
      console.log(file, fileList);

      this.launchPadList = fileList;

      console.log("launchPadList: " + this.launchPadList);
    },
    // 文件上传时的钩子
    launchPadHandleProgress(event, file, fileList) {
      console.log(event, file, fileList);
    },
    // 文件状态改变时的钩子
    launchPadHandleChange(file, fileList) {
      console.log("launchPadHandleChange", file, fileList);

      this.launchPadList = fileList;

      console.log("launchPadList: " + this.launchPadList);
    },
    // 上传Logo前的校验
    launchPadUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error('上传Logo大小不能超过10MB!');
        return false;
      }

      return isLt10M;
    },
    // 上传
    launchPadSubmitUpload() {
      console.log("上传Logo！");

      this.$refs.uploadLaunchPadLogo.submit();
    },
    // 上传Logo成功处理
    launchPadUploadSuccess(response, file) {
      this.launchPadAddNum += 1;

      this.$message.success('Logo上传成功!');
    },
    // 发射
    async toLaunchPad() {
      try {
        if (this.$store.state.accounts.length > 0) {
          if (!(this.projectId !== null && this.projectId !== undefined && parseInt(this.projectId) >= 0)) {
            this.$message.error("没有检测到项目ID");
            return;
          }
          if (!this.tokenName || this.tokenName === '' || (this.tokenName && this.tokenName.length > 20)) {
            this.$message.warning("Token名称不能为空且不能超过20个字符");
            return;
          }
          if (!this.tokenSymbol || this.tokenSymbol === '' || (this.tokenSymbol && this.tokenSymbol.length > 20)) {
            this.$message.warning("Token符号不能为空且不能超过20个字符");
            return;
          }

          if (this.tokenWebsite && this.tokenWebsite.length > 300) {
            this.$message.warning("官网不能超过300个字符");
            return;
          }
          if (this.tokenTelegram && this.tokenTelegram.length > 20) {
            this.$message.warning("Telegram不能超过20个字符");
            return;
          }
          if (this.tokenTwitter && this.tokenTwitter.length > 20) {
            this.$message.warning("Twitter不能超过20个字符");
            return;
          }
          if (!this.tokenDesc || this.tokenDesc === '' || (this.tokenDesc && this.tokenDesc.length > 1000)) {
            this.$message.warning("描述不能为空且不能超过1000个字符");
            return;
          }

          if (this.launchPadList.length <= 0) {
            this.$message.warning("请上传Logo");
            return;
          }

          let salt;

          await this.$http.calculateSalt(
              this.tokenName,
              this.tokenSymbol,
              "aaaa"
          ).then(async res => {
            if (res.success) {
              salt = res.data.salt;
              this.tokenAddress = res.data.computed_address;

              if (!this.tokenAddress) {
                this.$message.error("没有检测到Token地址！");
                return;
              }

              await metaMaskTools.onLaunchPad(
                  [
                      this.tokenName,
                      this.tokenSymbol,
                      200, // 百分比
                      BigNumberMul(1000, 1e18), // 总量
                      1000, // 硬顶
                      10, // 每份最大限额
                      86400, // 持续时间（秒）
                      this.projectId, // 项目ID
                      salt // salt
                  ]
              ).then(async res => {
                this.$message.success('发射请求已提交, 请先不要进行任何操作, 耐心等待!');

                await this.verifyLaunchPad(this.projectId);
              }).catch(err => {
                console.log(err);
              });
            } else {
              this.$message.warning('服务错误!');
            }
          }).catch(err => {
            console.log(err);
          });
        } else {
          this.$message.error(lang('qxljqb'));
        }
      } catch (e) {
        console.log(e);
      }
    },
    async verifyLaunchPad(id) {
      try {
        let retryCount = 0;
        const maxRetries = 30;
        const interval = 3000; // 3秒

        const checkStatus = async () => {
          if (retryCount >= maxRetries) {
            this.$message.error('验证超时!');
            return;
          }

          this.$message.warning('验证中, 请稍等...');

          await this.$http.getProjectInfo(id).then(async res => {
            if (res.success && res.data.status === 'launched') {
              // 成功条件，停止轮询
              this.$message.success('发射验证成功!');

              await this.launchPadSubmitUpload();

              setTimeout(async () => {
                await this.$http.commitArtlaunchInfo(
                    this.tokenAddress,
                    this.tokenDesc,
                    this.tokenWebsite,
                    this.tokenTelegram,
                    this.tokenTwitter
                ).then(async res => {
                  if (res.success) {
                    this.$message.success('发射成功!');
                    this.$message.success('已完成所有操作，请退出!');
                  }
                }).catch(err => {
                  console.log(err);
                });
              }, 1000);
            } else {
              retryCount++;
              // 继续轮询
              setTimeout(checkStatus, interval);
            }
          }).catch(err => {
            console.log(err);

            retryCount++;
            setTimeout(checkStatus, interval);
          });
        };

        // 开始轮询
        await checkStatus();
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped lang="less">
.rwa_launch_pad_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .rwa_launch_pad_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .rwa_launch_pad_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .rwa_launch_pad_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_launch_pad_page_02_01 {
      width: 100%;

      .rwa_launch_pad_page_02_011 {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: flex-start;

        .rwa_launch_pad_page_02_011_bj01 {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          height: 100%;
          max-height: 880px;
          @media (max-width: 767px) {
            max-height: 720px;
          }
        }

        .rwa_launch_pad_page_02_011_bj03 {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 0;
          max-width: 60%;
          @media (max-width: 767px) {
            max-width: 45%;
            display: none;
          }
        }

        .rwa_launch_pad_page_02_0111 {
          width: 80%;
          margin-left: 10%;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-items: flex-start;
          justify-content: flex-start;
          z-index: 1;

          @media (max-width: 767px) {
            width: 90%;
            margin-left: 5%;
          }
          .rwa_launch_pad_page_02_0111_rut {
            z-index: 1;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: flex-start;
            margin: 60px 0 20px 0;
            cursor: pointer;
            img {
              width: 25px;
              margin-right: 20px;
            }
            div {
              color: #FFF;
              font-family: Montserrat;
              font-size: 26px;
              font-style: italic;
              font-weight: 900;
              line-height: 152%; /* 39.52px */
            }
          }
          .rwa_launch_pad_divs {
            display: flex;
            padding: 40px;
            flex-direction: column;
            align-items: center;
            gap: 30px;
            align-self: stretch;
            border-radius: 12px;
            border: 1px solid rgba(153, 153, 153, 0.30);
            background: #252525;

            width: 1000px;
            height: auto;
            margin: 80px 0 200px calc((100% - 1000px) / 2);

            @media (max-width: 767px) {
              width: 470px;
              margin: 80px 0 150px calc((100% - 470px) / 2);
            }
            .rwa_launch_pad_title {
              color: #20944B;
              font-family: Inter;
              font-size: 26px;
              font-style: normal;
              font-weight: 800;
              line-height: 21.391px; /* 82.274% */
              text-align: center;
            }
            .rwa_launch_pad_div01 {
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: flex-start;
              align-items: flex-start;
              .rwa_launch_pad_div011 {
                width: 140px;
                .rwa_launch_pad_div0111 {
                  color: #FFF;
                  font-family: Inter;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 21px; /* 150% */
                }
                .rwa_launch_pad_div0112 {
                  display: flex;
                  flex-direction: column;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: center;
                  width: 140px;
                  min-height: 140px;
                  height: auto;
                  padding: 4.8px 12px;
                  gap: 4.8px;
                  border-radius: 9.6px;
                  border: 0.8px solid rgba(153, 153, 153, 0.30);
                  .rwa_launch_pad_div01120 {
                    width: 100px;
                    font-size: 14px;
                    text-align: center;
                    margin-top: 10px;
                    padding: 8px 8px;
                    color: #FFFFFF;
                    background: #20944B;
                    border-radius: 8px;
                    cursor: pointer;
                  }
                  .rwa_launch_pad_div01121 {
                    img {
                      margin-bottom: -10px;
                      margin-top: 10px;
                      width: 39px;
                    }
                  }
                  .rwa_launch_pad_div01122 {
                    color: #FFF;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 8px; /* 150% */
                    p {
                      text-align: center;
                    }
                  }
                }
              }
              .rwa_launch_pad_div012 {
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: space-between;
                align-items: stretch;

                width: calc(100% - 160px);
                height: 160px;
                margin-left: 20px;
                .rwa_launch_pad_div0121 {
                  .rwa_launch_pad_div01211 {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    align-items: center;

                    color: #FFF;
                    font-family: Inter;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 21px; /* 150% */
                  }
                  .rwa_launch_pad_div01212 {
                    display: flex;
                    height: 50px;
                    padding: 6px 15px;
                    align-items: center;
                    gap: 13px;
                    align-self: stretch;
                    border-radius: 12px;
                    border: 1px solid rgba(153, 153, 153, 0.30);
                  }
                }
                .rwa_launch_pad_div0122 {
                  .rwa_launch_pad_div01221 {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    align-items: center;

                    color: #FFF;
                    font-family: Inter;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 21px; /* 150% */
                  }
                  .rwa_launch_pad_div01222 {
                    display: flex;
                    height: 50px;
                    padding: 6px 15px;
                    align-items: center;
                    gap: 13px;
                    align-self: stretch;
                    border-radius: 12px;
                    border: 1px solid rgba(153, 153, 153, 0.30);
                  }
                }
              }
            }
            .rwa_launch_pad_div02 {
              width: 100%;
              .rwa_launch_pad_div021 {
                color: #FFF;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 21px; /* 150% */
              }
              .rwa_launch_pad_div022 {
                height: 50px;
                display: flex;
                padding: 6px 15px;
                align-items: center;
                gap: 13px;
                align-self: stretch;
                border-radius: 12px;
                border: 1px solid rgba(153, 153, 153, 0.30);
              }
            }
            .rwa_launch_pad_div03 {
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-between;
              .rwa_launch_pad_div031 {
                width: 49%;
                .rwa_launch_pad_div0311 {
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: space-between;

                  color: #FFF;
                  font-family: Inter;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 21px; /* 150% */
                }
                .rwa_launch_pad_div0312 {
                  height: 50px;
                  display: flex;
                  padding: 6px 15px;
                  align-items: center;
                  gap: 13px;
                  align-self: stretch;
                  border-radius: 12px;
                  border: 1px solid rgba(153, 153, 153, 0.30);
                }
              }
              .rwa_launch_pad_div032 {
                width: 49%;
                .rwa_launch_pad_div0321 {
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: space-between;

                  color: #FFF;
                  font-family: Inter;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 21px; /* 150% */
                }
                .rwa_launch_pad_div0322 {
                  height: 50px;
                  display: flex;
                  padding: 6px 15px;
                  align-items: center;
                  gap: 13px;
                  align-self: stretch;
                  border-radius: 12px;
                  border: 1px solid rgba(153, 153, 153, 0.30);
                }
              }
            }
            .rwa_launch_pad_div04 {
              width: 100%;
              .rwa_launch_pad_div041 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;

                color: #FFF;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 21px; /* 150% */
              }
              .rwa_launch_pad_div042 {
                height: 50px;
                display: flex;
                padding: 6px 15px;
                align-items: center;
                gap: 13px;
                align-self: stretch;
                border-radius: 12px;
                border: 1px solid rgba(153, 153, 153, 0.30);
                .rwa_launch_pad_div0421 {
                  width: calc(100% - 68px);
                }
                .rwa_launch_pad_div0422 {
                  width: 68px;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: flex-start;

                  color: #FFF;
                  font-family: Inter;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 21px; /* 150% */
                  img {
                    width: 16px;
                    margin-left: 6px;
                  }
                }
              }
            }
            .rwa_launch_pad_div05 {
              width: 100%;
              .rwa_launch_pad_div051 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;

                color: #FFF;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 21px; /* 150% */
              }
              .rwa_launch_pad_div052 {
                display: flex;
                height: 115px;
                padding: 1px 15px;
                align-items: flex-start;
                gap: 13px;
                align-self: stretch;
                border-radius: 12px;
                border: 1px solid rgba(153, 153, 153, 0.3);
              }
            }
            .rwa_launch_pad_div06 {
              text-align: center;
              div {
                display: flex;
                width: 300px;
                padding: 8px 28px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                border-radius: 8px;
                background: #20944B;
                color: #FFFFFF;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; /* 150% */
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .rwa_launch_pad_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_launch_pad_div {
  .el-textarea__inner {
    height: 110px !important;
    min-height: 110px !important;
    background-color: #252525 !important;
    border: 0 solid #DCDFE6 !important;
    color: #FFF;
  }
  .el-input--suffix .el-input__inner {
    background-color: #252525 !important;
    border: 0 solid #DCDFE6 !important;
    color: #FFF;
    height: 47px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
  }
  .el-upload-list {
    width: 100% !important;
  }
}
</style>